export default class SUKUSearchbutton extends HTMLElement {
  static get observedAttributes() {
    return ['active', 'text']
  }

  constructor() {
    super()

    this.active = this.getAttribute('active') === 'true' ? true : false

    this.className = 'bg-white min-w-[85px]'

    this.linkEl = this.querySelector('a')
    this.searchBarEl = document.querySelector('suku-searchbar')

    this.linkEl.addEventListener('click', this.handleClick)
  }

  handleClick = (evt) => {
    evt.preventDefault()

    this.setAttribute('active', !this.active)
  }

  connectedCallback() {
    console.log('SUKUSearchbutton connectedCallback')
  }

  attributeChangedCallback(name, previous, current) {
    if (previous === current) {
      return
    }

    switch (name) {
      case 'active':
        this.active = current === 'true' ? true : false

        this.searchBarEl.setAttribute('active', this.active) // update searchbar

        if (this.active) {
          this.linkEl.textContent = 'Close'
        } else {
          this.linkEl.textContent = this.getAttribute('text')
        }
        break
    }
  }
}

customElements.define('suku-searchbutton', SUKUSearchbutton)
